// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"6a7db2fd","272":"4ebc62bc","604":"a69a0d10","916":"9bbc7213"}[chunkId] + ".chunk.css";
};